import React, { useEffect, useState } from "react";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  Button,
  Row,
  Label,
  Form,
  CardImg,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Dropzone from "react-dropzone";
import Select from "react-select";
import moment from "moment";
import { Link } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";


const AddSetting = (props) => {
  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" },
  ];

  const [itemName, setItemName] = useState();
  const [itemDetail, setItemDetail] = useState();
  const [itemGroup, setItemGroup] = useState();
  // const [version, setVersion] = useState();
  const [status, setStatus] = useState(statusOptions[0].value);
  const [successAlert, setSuccesAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [token, setToken] = useState();
  const [propsData, setPropsData] = useState(props?.location?.state);
  const [loader,setLoader]=useState(false)


  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);

    if (props.location.state?.edit) {
      setPropsData(props?.location?.state);
      var itemName = props.location.state?.item?.item_name;
      var itemDetail = props.location.state?.item?.item_detail;
      // var version = props.location.state?.item?.item_version;
      var status = props.location.state?.item?.item_status;
      var itemGroup = props.location.state?.item?.item_group;

      setItemName(itemName);
      setItemGroup(itemGroup);
      setItemDetail(itemDetail);
      // setVersion(version);
      setStatus(status);
    }
  }, []);

  const handleSubmit = () => {
    if (!itemName) {
      setErrorMessage("Please enter item name");
      setErrorAlert(true);
      return;
    } else if (!status) {
      setErrorMessage("Please Select Status");
      setErrorAlert(true);
      return;
    } 

    setLoader(true)

    let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("path", "settings/add");
    formdata.append("created_datetime", currentDate);
    formdata.append("item_type", "settings");
    formdata.append("item_name", itemName);
    if (itemGroup) {
      formdata.append("item_group", itemGroup);
    }
    formdata.append("item_detail", itemDetail);
    formdata.append("item_version", 18);
    formdata.append("item_status", status);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then((response) => {
        if (response.status == 200) {
          console.log("here is the res", response);
          setSuccesAlert(true);
          setLoader(false)
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
          setLoader(false)
        }
        response.json();
        console.log("here is the res", response);
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  const handleEdit = () => {
    if (!itemName) {
      setErrorMessage("Please Enter Item Name");
      setErrorAlert(true);
      return;
    } else if (!status) {
      setErrorMessage("Please Select Status");
      setErrorAlert(true);
      return;
    } 

    setLoader(true)
    // let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm")
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("item_id", propsData?.item?.item_id);
    formdata.append("path", "settings/update");
    formdata.append("item_type", "settings");
    formdata.append("item_name", itemName);
    if (itemGroup) {
      formdata.append("item_group", itemGroup);
    }
    formdata.append("item_detail", itemDetail);
    formdata.append("item_version", 18);
    formdata.append("item_status", status);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then((response) => {
        if (response.status == 200) {
          console.log("here is the res", response);
          setSuccesAlert(true);
          setLoader(false)
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
          setLoader(false)
        }
        console.log("here is the res", response);
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={() => {
          props?.history.push("/settings");
        }}
        onConfirm={() => {
          props?.history.push("/settings");
          setSuccesAlert(false);
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {props.location?.state?.edit?"Setting Updated Successfully":"Setting Added Successfully"}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Add Setting" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={10} sm={10}>
                            <div className="mb-3">
                              <Label>Item Name</Label>
                              <input
                                type="text"
                                className="form-control"
                                id="item_name_input"
                                onChange={(e) => {
                                  setItemName(e.target.value);
                                }}
                                defaultValue={itemName}
                              />
                            </div>
                          </Col>
                          <Col md={1}></Col>
                        </Row>
                        <Row>
                          <Col lg={4} md={10} sm={10}>
                            <div className="mb-3">
                              <Label>Item Group</Label>
                              <input
                                type="text"
                                className="form-control"
                                id="item_group_input"
                                onChange={(e) => {
                                  setItemGroup(e.target.value);
                                }}
                                defaultValue={itemGroup}
                              />
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label>Item Detail</Label>
                              <textarea
                               rows="4" 
                               cols="20"
                                type="text"
                                className="form-control"
                                id="item_detail_input"
                                onChange={(e) => {
                                  setItemDetail(e.target.value);
                                }}
                                defaultValue={itemDetail}
                              />
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Status</Label>
                              <Select
                                isSearchable={true}
                                // value={selectedStatus}
                                onChange={(e) => {
                                  setStatus(e.value);
                                }}
                                options={statusOptions}
                                placeholder={
                                  status
                                    ? status == "Y"
                                      ? "Enable"
                                      : "Disable"
                                    : "Choose..."
                                }
                                defaultValue={status}
                                required
                              />
                            </div>
                          </Col>
                          {/* <Col lg={1}></Col>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Version</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  onChange={(e) => {
                                    setVersion(e.target.value);
                                  }}
                                  type="number"
                                  id="version_input"
                                  defaultValue={version}
                                />
                                <small className="text-muted user-select-none">
                                  For mobile app only
                                </small>
                              </div>
                            </div>
                          </Col> */}
                        </Row>
                      </CardBody>
                    </Card>
                    <div style={{ textAlign: "right" }} className="btn-sec">
                      <Button
                        onClick={() => {
                          props.history.push("/settings");
                        }}
                        color="danger"
                        type="submit"
                      >
                        {" "}
                        Cancel
                      </Button>
                      <button
                      disabled={loader}
                      style={{color:"#ffffff", width:"80px",marginLeft: "10px"}}
                      className={ "btn btn-success"}
                        onClick={() => {
                          if (props?.location?.state?.edit) {
                            handleEdit();
                          } else {
                            handleSubmit();
                          }
                        }}
                        // className="px-4"
                        color="success"
                        type="submit"
                      >
                         {loader ? <CircularProgress 
                                size={15}
                                value={100}
                                color={"white"} />
                              : "Save"}
                      </button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddSetting;
